export default [
  {
    path: "/objects",
    component: () =>
      import(/* webpackChunkName: "Objects" */ "@/views/Objects/"),
    children: [
      {
        path: "",
        redirect: { name: "ObjectsSubject" },
      },

      {
        name: "ObjectsDepartment",
        path: "department",
        component: () =>
          import(
            /* webpackChunkName: "ObjectsDepartment" */ "@/views/Objects/Department.vue"
          ),
      },
      {
        name: "ObjectsSubject",
        path: "subject",
        component: () =>
          import(
            /* webpackChunkName: "ObjectsSubject" */ "@/views/Objects/Subject.vue"
          ),
      },
    ],
  },
];
